import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import DynamicForm from '../../components/DynamicForm';
import { updateCampaignFormFields } from './UpdateCampaignFieldsConfig';
import { getAllOtaArtifacts, updateCampaign } from '../../commonApi';
import { toast } from 'react-toastify';
import { extractErrorMessage } from '../../Utils/ExtractMessages';

const UpdateCampaign = ({ show, onClose, onSuccess, campaignData }) => {
    const [fields, setFields] = useState(updateCampaignFormFields);

    useEffect(() => {
        if (show) {
            fetchArtifacts();
        }
    }, [show]);

    const fetchArtifacts = async () => {
        try {
            const response = await getAllOtaArtifacts({ page: 0, size: 100 });
            const artifacts = response.data?.data?.content || response.data?.content || [];

            const artifactOptions = artifacts.map(artifact => ({
                value: artifact.id,
                label: artifact.artifactName || artifact.description || `${artifact.firmwareVersion || 'v?'} - ${artifact.deviceModelId || '?'}`
            }));

            setFields(prevFields => prevFields.map(field =>
                field.name === 'otaArtifactId'
                    ? { ...field, options: artifactOptions }
                    : field
            ));

        } catch (error) {
            console.error("Error fetching artifacts:", error);
            toast.error(extractErrorMessage(error));
            setFields(prevFields => prevFields.map(field =>
                field.name === 'otaArtifactId'
                    ? { ...field, options: [] }
                    : field
            ));
        }
    };

    const handleSubmit = async (formData) => {
        try {
            const campaignId = campaignData?.id || campaignData?.campaignId || campaignData?.jobId;

            if (!campaignId) {
                toast.error("Unable to identify campaign ID!");
                return;
            }

            const payload = {
                status: formData.status?.value || formData.status,
            };

            await updateCampaign(campaignId, payload);
            toast.success("Campaign updated successfully!");
            onClose();
            if (onSuccess) onSuccess();
        } catch (error) {
            console.error("Error updating campaign:", error);
            toast.error(extractErrorMessage(error));
        }
    };

    // Prepare default values from campaignData
    const artifactOptions = fields.find(f => f.name === 'otaArtifactId')?.options || [];
    const statusOptions = fields.find(f => f.name === 'status')?.options || [];

    const defaultValues = campaignData ? {
        jobId: campaignData.name || campaignData.jobId,
        description: campaignData.description,
        otaArtifactId: artifactOptions.find(opt => opt.value === (campaignData.artifactId || campaignData.otaArtifactId)) || (campaignData.artifactId || campaignData.otaArtifactId),
        status: statusOptions.find(opt => opt.value === campaignData.status) || campaignData.status,
    } : {};

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ color: 'rgb(67, 64, 210)' }}>Update Campaign Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DynamicForm
                    fields={fields}
                    onSubmit={handleSubmit}
                    onClose={onClose}
                    defaultValues={defaultValues}
                    disabledFields={['jobId', 'otaArtifactId', 'description']}
                    onError={(errors) => console.log("Form Errors:", errors)}
                />
            </Modal.Body>
        </Modal>
    );
};

export default UpdateCampaign;
